import { useMemo } from "react";
import { useCurrentUser } from "@/contexts/current-user";
import { QUERY_STATUS } from "@/types/async-protocol";
import {
  selectCurrentUserImageSrc,
  selectCurrentUserName,
} from "./creferenceResolvedEntitySelectors";

interface UseCreferenceCurrentUserFieldsInput {
  isCurrentUserReference: boolean;
}

export interface CreferenceCurrentUserFields {
  currentUserImageSrc: string | null;
  currentUserName: string | null;
  profileLoading: boolean;
}

export function useCreferenceCurrentUserFields({
  isCurrentUserReference,
}: UseCreferenceCurrentUserFieldsInput): CreferenceCurrentUserFields {
  const currentUser = useCurrentUser();
  const profileDataDetailsChatName = currentUser.data?.details.chatName;
  const currentUserName = useMemo(() => {
    return selectCurrentUserName({
      chatName: profileDataDetailsChatName ?? null,
      isCurrentUserReference,
    });
  }, [isCurrentUserReference, profileDataDetailsChatName]);
  const profileDataDetailsImageUrl = currentUser.data?.details.imageUrl;
  const currentUserImageSrc = useMemo(() => {
    return selectCurrentUserImageSrc({
      imageUrl: profileDataDetailsImageUrl ?? null,
      isCurrentUserReference,
    });
  }, [isCurrentUserReference, profileDataDetailsImageUrl]);

  return {
    currentUserImageSrc,
    currentUserName,
    profileLoading: currentUser.status === QUERY_STATUS.Loading,
  };
}
